import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const containerVariants = cva(
  "w-full mx-auto space-y-4 md:space-y-6",
  {
    variants: {
      size: {
        default: "container",
        xs: "container max-w-lg",
        sm: "container max-w-xl",
        md: "container max-w-7xl",
        fullWidth: "w-full",
      },
      padding: {
        default: "px-4",
        none: "px-0",
      }
    },
    defaultVariants: {
      size: "default",
      padding: "default",
    },
  }
)

export type MainContainerProps = {
  children: React.ReactNode
} & VariantProps<typeof containerVariants>

function MainContainer({ children, size, padding }: MainContainerProps) {
  return (
    <main className={cn(containerVariants({ size, padding }))}>
      {children}
    </main>
  )
}

export { MainContainer }
